import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import UserBasicInfo from "../../components/UserBasicInfo/UserBasicInfo";

/**
 * Component to show user's details.
 */
const UserDetails = () => {
  const { userId = "" } = useParams();

  return (
    <Box sx={{ mt: 1 }}>
      <UserBasicInfo userId={userId} />
    </Box>
  );
};

export default UserDetails;
